import { useEffect, useState } from 'react'
import _ from 'lodash'
import qs from 'query-string'
import { useUpdateEffect } from 'react-use'
import { useLocation, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { REVIEW_OF_PURCHASE_ITEM_PROPS_ID, REVIEW_OF_PURCHASE_ITEMS_PROPS_ID } from "src/common/razzle-platform-reviewofpurchaseitem/ssr"
import { fetchReviewsOfPurchaseItem, fetchReviewsOfPurchaseItems } from "src/common/razzle-platform-reviewofpurchaseitem/effects"
import { IParamsOption, IRequestFetcherOptions, Pagination } from 'src/common/razzle-platform-components/types'


type UseReviewOfPurchaseItem<T> = {
    reviews: Array<T>
    pagination: Pagination
    isFirstRequestInProgress: boolean
    isUpdateProgress: boolean
}

export function useReviewsOfPurchaseItem<T>(id: string, options: IParamsOption={params: null, useUrlParams: true, usePagination: true }): UseReviewOfPurchaseItem<T> {
    const location = useLocation()
    const dispatch = useDispatch()
    // get the initial state of purchase item review by it sheared id
    const initialProps = useSelector((state: any) => state.ssrModel[REVIEW_OF_PURCHASE_ITEM_PROPS_ID]) || {}
    const [isUpdateProgress, setUpdateInProgress] = useState(false)
    // use this state in the first render for use loader page
    const [isFirstRequestInProgress, setFirstRequestInProgress] = useState(false)
    // we use this state to save our purchase item review
    const [state, setState] = useState({ reviews: initialProps.reviews,  pagination: initialProps.pagination })


    const queryOptions: IRequestFetcherOptions = {
        // prams given from url
        searchParams: qs.parse(location.search),
        // forced params by user not it's shown in url
        params: options.params,
        // to allow use pagination
        usePagination: options.usePagination,
        // to allow use search parms from url
        useUrlParams: options.useUrlParams
    }

    useEffect(() => {

        if (initialProps.review) {
            // case when we make reload or refresh on the browser we get the saved purchase item reviews form the server (window.__PRELOADED_STATE__)

            // we remove all initialProps of purchase item reviews
            dispatch.ssrModel.cleanInitialProps(REVIEW_OF_PURCHASE_ITEM_PROPS_ID)
        } else {

            // we make request if we don't have purchase item reviews or the purchase item reviews it's diffirente to saved purchase item reviews

            const fetchData = async () => {
                setFirstRequestInProgress(true)
                // get the purchase item review by executing the effect fetchPurchaseItemReview and pass it queryOptions
                const { reviews, pagination } = await fetchReviewsOfPurchaseItem(id, queryOptions)
                // save the purchase item review in our state
                setState({ reviews, pagination })
                setFirstRequestInProgress(false)
            }
            fetchData()
            
        }

	}, [])

    useUpdateEffect(() => {
        // we use this effects when we update the url (change the page, filters, ...etc)
        // check if the update by url is allowed
        if (options.useUrlParams) {
            const fetchData = async () => {
                setUpdateInProgress(true)
                const { reviews, pagination} = await fetchReviewsOfPurchaseItem(id, queryOptions)
                setState({ reviews, pagination })
                setUpdateInProgress(false)
            }
            fetchData()
        }

    }, [location.search])

    return {
        reviews: state.reviews,
        pagination: state.pagination,
        isUpdateProgress: isUpdateProgress,
        isFirstRequestInProgress: isFirstRequestInProgress
    }

}


type UseReviewOfPurchaseItems<T> = {
    reviews: Array<T>
    pagination: Pagination
    isFirstRequestInProgress: boolean
    isUpdateProgress: boolean
}

export function useReviewsOfPurchaseItems<T>(options: IParamsOption={params: null, useUrlParams: true, usePagination: true }): UseReviewOfPurchaseItems<T>  {
    const location = useLocation()
    const dispatch = useDispatch()
    // get the initial state of reviewOfPurchaseItemsProps by it sheared id
    const initialProps = useSelector((state: any) => state.ssrModel[REVIEW_OF_PURCHASE_ITEMS_PROPS_ID]) || {}
    // state use when we update the purchase item reviews (change page, filters, ...ect)
    const [isUpdateProgress, setUpdateInProgress] = useState(false)
    // use this state in the first render for use loader page
    const [isFirstRequestInProgress, setFirstRequestInProgress] = useState(false)
    // we use this state to save our purchase item reviews and thier pagintion
    const [state, setState] = useState({ reviews: initialProps.reviews, pagination: initialProps.pagination })

    const queryOptions: IRequestFetcherOptions = {
        // prams given from url
        searchParams: qs.parse(location.search),
        // forced params by user not it's shown in url
        params: options.params,
        // to allow use pagination
        usePagination: options.usePagination,
        // to allow use search parms from url
        useUrlParams: options.useUrlParams
    }

    useEffect(() => {

        if (initialProps.reviews) {
            // case when we make reload or refresh on the browser we get the saved purchase item reviews form the server (window.__PRELOADED_STATE__)

            // we remove all initialProps of reviewOfPurchaseItemsProps
            dispatch.ssrModel.cleanInitialProps(REVIEW_OF_PURCHASE_ITEMS_PROPS_ID)
        } else {
            // case when we are on browser (pass from page to another) we don't need to get purchase item reviews form the server side
            const fetchData = async () => {
                setFirstRequestInProgress(true)
                // get the purchase item reviews by execute the effect fetchReviewOfPurchaseItems and pass it queryOptions
                const { reviews, pagination} = await fetchReviewsOfPurchaseItems(queryOptions)
                // save the purchase item reviews in our state
                setState({ reviews, pagination })
                setFirstRequestInProgress(false)
            }
            fetchData()
        }
    }, [])

    useUpdateEffect(() => {
        // we use this effects when we update the url (change the page, filters, ...etc)

        // check if the update by url is allowed
        if (options.useUrlParams) {

            const fetchData = async () => {
                setUpdateInProgress(true)
                const { reviews, pagination} = await fetchReviewsOfPurchaseItems(queryOptions)
                setState({ reviews, pagination })
                setUpdateInProgress(false)
            }
            fetchData()
        }

    }, [location.search])

    return {
        reviews: state.reviews,
        pagination: state.pagination,
        isFirstRequestInProgress: isFirstRequestInProgress,
        isUpdateProgress
    }
}